import React, { memo, ReactElement } from 'react'
import { TooltipNew } from '@elamajs/ui-kit'
import { FieldTypes } from '@src/types/UtmGenerator'
import { InputComponent } from '@src/components/UtmGenerator'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'

import * as Styled from './Field.styled'

function Field(props: FieldTypes): ReactElement {
  const { getParameters, ...state } = useHTTPContext()

  return (
    <Styled.Field>
      <Styled.Title>{props.title}</Styled.Title>
      <Styled.Info>
        <p>{props.text}</p>
        <Styled.TooltipNew
          as={TooltipNew}
          icon="questionNew"
          width={props.tooltipWidth}
          direction={props.tooltipDirection}
          content={props.tooltipContent}
        />
      </Styled.Info>
      <Styled.InputItem>
        <InputComponent
          onChange={getParameters}
          type={props.inputInfo.type}
          id={props.inputInfo.id}
          name={props.inputInfo.name}
          inputMode={props.inputInfo.inputMode}
          labelText={props.inputInfo.labelText}
          value={state[props.fieldName].value}
        />
      </Styled.InputItem>
    </Styled.Field>
  )
}

export default memo(Field)
